import Samples2DContract from '../contracts/Samples2DContract.js';
import {New2DMapping} from '../EthereumEvents.js';
import EthereumQuery from '../EthereumQuery.js';
import ipfs from '../Ipfs.js';
import {X, Y} from './constants.js';
import KDTree from './KDTree.js';

let contract = new Samples2DContract();

class Samples2D {
    constructor(web3) {
        this.contract = contract.getContract(web3);

        this.loaded = false;

        // this.load();
    }

    async load() {
        let query = await new EthereumQuery(this.contract.contractAddress)
            .from(New2DMapping)
            .select('ipfsHash')
            .executeQuery();

        if (query.length === 0) {
            return;
        }

        let hash = query[query.length - 1].ipfsHash;
        let json = await ipfs.getJson(hash);
        this.points = json;
        this.pointsMap = this.getMap(json);

        console.log('constructing KD tree');
        this.kdTree = new KDTree(this.points);
        console.log('finished constructing KD tree size=');
        console.log(this.kdTree.size());

        this.loaded = true;
    }

    getPointsInRange(x1, y1, x2, y2) {
        let dateA = new Date().getTime();
        let pts = this.kdTree.getPointsInRange(x1, y1, x2, y2);
        let dateB = new Date().getTime();
        console.log('finished getting points in ' + (dateB - dateA) + ' ms');
        return pts;
    }

    getMap(points) {
        let map = {};
        for (let i in points) {
            let point = points[i];
            map[point.path] = point;
        }

        return map;
    }


    findSimilarSounds(soundId) {
        // let find point
        let point = undefined;
        for (let i in this.points) {
            if (this.points[i].path === soundId) {
                point = this.points[i];
            }
        }
        if (point === undefined) {
            console.log('no point');
            return [];
        }

        let distances = [];
        for (let i in this.points) {
            let distance = this.distance(point, this.points[i]);
            distances.push({
                point: this.points[i],
                distance: distance
            });
        }
        distances.sort((a, b) => a.distance - b.distance);
        return distances.slice(0, 100).map(
            x => x.point.path);
    }

    distance(point1, point2) {
        let x1 = point1.point[0];
        let y1 = point1.point[1];
        let x2 = point2.point[0];
        let y2 = point2.point[1];

        return Math.sqrt(Math.pow((x2 - x1), 2) + Math.pow(y2 - y1, 2));
    }
}

export default Samples2D;
